import { DayOfWeek } from 'api/ordering-service/ordering-service.types';
import i18n from 'app-i18n';
import { Option } from 'util/multi-select';

export const dayOfWeekOrder: DayOfWeek[] = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
];

export const daysOfWeekOptions = (): Option[] => [
  { id: 'ALL', label: i18n.t('forms.fields.daysOfWeek.options.all') },
  { id: 'SUN', label: i18n.t('forms.fields.daysOfWeek.options.sun') },
  { id: 'MON', label: i18n.t('forms.fields.daysOfWeek.options.mon') },
  { id: 'TUE', label: i18n.t('forms.fields.daysOfWeek.options.tue') },
  { id: 'WED', label: i18n.t('forms.fields.daysOfWeek.options.wed') },
  { id: 'THU', label: i18n.t('forms.fields.daysOfWeek.options.thu') },
  { id: 'FRI', label: i18n.t('forms.fields.daysOfWeek.options.fri') },
  { id: 'SAT', label: i18n.t('forms.fields.daysOfWeek.options.sat') },
];

export const daysOfWeekEngOptions = (): Option[] => [
  { id: 'SUN', label: 'Sunday' },
  { id: 'MON', label: 'Monday' },
  { id: 'TUE', label: 'Tuesday' },
  { id: 'WED', label: 'Wednesday' },
  { id: 'THU', label: 'Thursday' },
  { id: 'FRI', label: 'Friday' },
  { id: 'SAT', label: 'Saturday' },
];

export const daysOfWeekOptionsLong = (): Option[] => [
  { id: 'ALL', label: i18n.t('forms.fields.daysOfWeek.options.all') },
  { id: 'SUNDAY', label: i18n.t('forms.fields.daysOfWeek.options.sun') },
  { id: 'MONDAY', label: i18n.t('forms.fields.daysOfWeek.options.mon') },
  { id: 'TUESDAY', label: i18n.t('forms.fields.daysOfWeek.options.tue') },
  { id: 'WEDNESDAY', label: i18n.t('forms.fields.daysOfWeek.options.wed') },
  { id: 'THURSDAY', label: i18n.t('forms.fields.daysOfWeek.options.thu') },
  { id: 'FRIDAY', label: i18n.t('forms.fields.daysOfWeek.options.fri') },
  { id: 'SATURDAY', label: i18n.t('forms.fields.daysOfWeek.options.sat') },
];
